module.exports = __webpack_public_path__ + "static/img/packages.dcd49c08.png";